export default __webpack_public_path__ + "static/kat-07c94ac3a25d29cd6cbfe9dfed10f8ee.jpg";